export default __webpack_public_path__ + "static/media/filter_activity_blue.ae00a867.svg";